// extracted by mini-css-extract-plugin
module.exports = {"footer":"StrmrmFooter_footer__2oJcw"};